// extracted by mini-css-extract-plugin
export default {"primaryColor":"#007ac3","secondaryColor":"#e5202e","grayColor":"#474747","grayDarkenColor":"#53565a"};